export const login_second = `query login_second($input: AuthSecond!){
    login_second(input: $input){
        need_password_update
        expiry
        language
        terms_of_use{
            id
            document
            document_en
        }
    }
}`;
